module.exports = {
      id: "logout-mobile-usage",
      viewBox: "0 0 20.886 28.808",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#logout-mobile",
      toString: function () {
        return this.url;
      }
    }